import { createContext, useContext } from 'react'
import type { Transaction } from '@/lib/hooks'

export type CategoryDetailContextValue = {
  categoryName: string
  categoryColor: string
  categoryAmount: number
  monthlyTotal: number
  filteredTransactions: Transaction[]
  currentMonth: string
}

export const CategoryDetailContext = createContext<CategoryDetailContextValue | null>(null)

export function useCategoryDetail(): CategoryDetailContextValue {
  const ctx = useContext(CategoryDetailContext)
  if (!ctx) {
    throw new Error('useCategoryDetail must be used within CategoryDetailSheet')
  }
  return ctx
}
